var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    id: "svg896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title892"
  }, "arrow-right2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title892"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path829-4",
    d: "m 13.763234,27.418487 10.000001,-9.999999 c 0.781,-0.781 0.781,-2.047 0,-2.828 L 13.763234,4.5904868 c -0.781,-0.781 -2.047,-0.781 -2.828,0 -0.781,0.781 -0.781,2.047 0,2.828 l 6.586,6.5860012 c 2.50134,2.50134 2.338755,1.661245 0,4 l -6.586,6.585999 c -0.39,0.39 -0.586,0.902 -0.586,1.414 0,0.512 0.195,1.024 0.586,1.414 0.781,0.781 2.047,0.781 2.828,0 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a01f9eb1.svg";
export { ForwardRef as ReactComponent };